import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { CREATE_DMX_DEVICE } from './actionTypes';
import { createDmxDeviceSuccessful, createDmxDeviceFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* createDevice({ payload: { device } }) {
  try {
    const response = yield call(dmxAPI.createDevice, device.token, device);
    if (response.message) {
      yield put(createDmxDeviceSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createDmxDeviceFailed(error));
  }
}

export function* watchCreateDmxDevice() {
  yield takeEvery(CREATE_DMX_DEVICE, createDevice);
}

function* createDmxDeviceSaga() {
  yield all([fork(watchCreateDmxDevice)]);
}

export default createDmxDeviceSaga;
